import { render, staticRenderFns } from "./BillModal.vue?vue&type=template&id=32bc56f6&scoped=true&"
import script from "./BillModal.vue?vue&type=script&lang=js&"
export * from "./BillModal.vue?vue&type=script&lang=js&"
import style0 from "./BillModal.vue?vue&type=style&index=0&id=32bc56f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bc56f6",
  null
  
)

export default component.exports